<template>
  <div class="c-app flex-row align-items-center">
    <CContainer>
      <CRow class="justify-content-center">
        <CCol md="7" >
  <b-card no-body class="reg-card">
    <b-card-header class="reg-header">
        <h3 class="reg-header-text mb-n1"><img class='logo mt-n2' src="@/assets/SoldierNETLogo.png" style="width: 7.5rem;" /> <strong>Registration</strong></h3> 
    </b-card-header>
    <CForm class="px-4 pt-3 mb-3" @submit.prevent="handleSubmit">
      <p class="text-muted">Create a new account</p>
      <CInput
        placeholder="First Name"
        autocomplete="firstname"
        v-model='user.firstName'
      >
        <template #prepend-content><CIcon name="cil-user"/></template>
      </CInput>
      <CInput
        placeholder="Last Name"
        autocomplete="lastname"
        v-model='user.lastName'
      >
        <template #prepend-content><CIcon name="cil-contact" /></template>
      </CInput>
      <CInput
        placeholder="Mobile"
        autocomplete="mobile"
        v-model='user.mobile'
        type="tel"
        :is-valid="isValidMobile"
      >
        <template #prepend-content><CIcon name="cil-comment-square" /></template>
      </CInput>
      <CInput
        placeholder="Email"
        autocomplete="email"
        v-model='user.email'
        type="email"
      >
        <template #prepend-content><CIcon name="cil-envelope-closed" /></template>
      </CInput>
      <CRow>
        <CCol col="6" class="text-left">
          <router-link :to="previousRoute" class="btn btn-link">Cancel</router-link>
          <!-- {{ previousRoute }} -->
        </CCol>
        <CCol col="6" class="text-right">
          <button class="btn btn-primary" :disabled="!allowRegistration">Register</button>
        </CCol>
      </CRow>
    </CForm>
  </b-card>
  </CCol>
      </CRow>
    </CContainer>
    <b-modal id="newAccountDetails" size="md" no-close-on-backdrop no-close-on-esc>
        <template #modal-header><h5 class="urgent-otv">TAKE NOTE OF DETAILS</h5></template>
        <span v-if="account != null">
          <span v-if="account != null" class="urgent-otv">Username: {{account.username}}</span>
          <br />
          <span v-if="account != null" class="urgent-otv">Password: {{account.password}}</span>
          <br />
          <br />
          <span class="urgent-otv">These are your account details.<br /><strong><u>We only issue these once.</u></strong><br />Please take note of the details above in order to sign in.</span>
        </span>
        <template #modal-footer>
          <router-link :to="previousRoute"><CButton color="secondary" class="reg-btn px-3">Return to Previous Page</CButton></router-link>
        </template>
    </b-modal>
    <b-modal id="errorDetails" size="md" no-close-on-backdrop no-close-on-esc ok-only>
        <template #modal-header>Internal System Error</template>
        Contact SoldierNET with the error below.<br />
        {{error}}
    </b-modal>
    <b-modal id="invalidAccountCreationSubmission" size="md" no-close-on-backdrop no-close-on-esc ok-only>
        <template #modal-header>Invalid Submission</template>
          <div class="m-2">
            <span v-show="invalidSubmission.duplicateMobile">The mobile number entered is already assigned to an account.<br /></span>
            <span v-show="invalidSubmission.duplicateMobile && invalidSubmission.mobileReminder">
              For an SMS reminder of your account name and password please click the button below.<br /><br />
              <button @click='remindersms' class="btn btn-primary mx-2 mb-3" :disabled="!invalidSubmission.mobileReminder">Reminder</button><br />
            </span>
            <span v-show="invalidSubmission.duplicateEmail">
              The email entered is already assigned to an account.<br />
            </span>
            <span v-show="invalidSubmission.duplicateEmail == null && invalidSubmission.duplicateMobile == null">Something you entered has been perceived as incorrect.<br /></span>
            <span>If you believe this is a mistake, please contact SoldierNET.</span>
          </div>
    </b-modal>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import { isValidPhoneNumber } from 'libphonenumber-js';
export default {
  data () {
      return {
          user: {
              firstName: '',
              lastName: '',
              email: '',
              mobile: ''
          },
          account: null,
          error: null,
          invalidSubmission: {
            duplicateEmail: false,
            duplicateMobile: false,
            mobileReminder: false
          }
      }
  },
  computed: {
    ...mapGetters({
      previousRoute: "nav/previousNav"
    }),
      allowRegistration() {
        const firstName = this.user.firstName.trim();
        const lastName = this.user.lastName.trim();
        const mobile = this.user.mobile.trim();
        return firstName !== '' && lastName !== '' && mobile !== '' && this.isValidMobile;
      },
      isAccount() {
          return this.account != null
      },
      isValidName() {
        const nameRegex = /^[a-z]/;
        return nameRegex.test(this.user.firstName) && nameRegex.test(this.user.lastName);
      },
      isValidMobile() {
        // Regular expression for mobile number validation
        const mobileRegex = /^0\d{10}$/;

        return this.user.mobile.length === 0 ? null : isValidPhoneNumber(this.user.mobile) || mobileRegex.test(this.user.mobile);
      }
  },
  methods: {
    handleSubmit(e) {
      this.$portalapi.get('/open/register', {params: {commonname: this.user.firstName, surname: this.user.lastName, email: this.user.email, mobile: this.user.mobile}}).then((response) => {
        if (response.data.account != null) {
          this.$log.onDebug('/open/register returned an account');
          this.account = response.data.account;
          this.$bvModal.show('newAccountDetails');
        } else {
          this.$log.onDebug('/open/register failed to return an account due to client error');
          this.invalidSubmission.duplicateEmail = response.data.duplicateEmail;
          this.invalidSubmission.duplicateMobile = response.data.duplicateMobile;
          this.invalidSubmission.mobileReminder = response.data.mobileReminder;
          this.$bvModal.show('invalidAccountCreationSubmission');
        }
      },
      (error) => {
          this.$log.onDebug('/open/register failed to return an account due to an unexpected error - ' + error.data);
          this.error = error
          this.$bvModal.show('errorDetails')
      })
    },
    remindersms(e) {
      this.$portalapi.get('/open/remindersms', {params: {mobile: this.user.mobile}}).then((response) => {
        this.$log.onDebug("reminder sent")
        this.invalidSubmission.mobileReminder = false
      },
      (error) => {
        this.$log.onError('failed to send sms' + error.data);
      })
    }
  }
};
</script>

<style lang="scss" scoped>

.reg-card {
    max-width: 40rem;
    min-width: 15rem;
    border-radius: 16px 16px 16px 16px;
}

.reg-header {
    background-color: #471747;
    border-radius: 16px 16px 0px 0px;
}

.reg-header-text {
    color: white !important;
}

.urgent-otv {
    color: red;
    font-weight: bold;
}

</style>